module.exports = __webpack_public_path__ + "assets/img/7711790acc43379593f8aaf1900d1bd1.webp";